import BaseMonitor from './base';
let StaticMediaSessionMonitor = function() { this.init.apply(this, arguments); };
StaticMediaSessionMonitor.prototype = Kadenze.Util.extendClass(BaseMonitor, {

  getRenderer: function(){
    try {
      return this.media.renderer;
    } catch(e) {
      this.error(e);
      this.warn('You must implement a renderer attribute on: ' + this.media.constructor.name);
      this.warn('Monitoring not enabled');
      return null;
    }
  },

  onPresented: function() {
    this.markViewed();
    Kadenze.Analytics.track('session_media', 'play', this.media.tracking_data);
  },

  onShow: function() {
    Kadenze.Analytics.track('session_media', 'viewing', this.media.tracking_data);
  },

  onHide: function() {
    this.markViewed();
    this.media.completed(true);
    Kadenze.Analytics.track('session_media', 'viewed', this.media.tracking_data);
  },

  markViewed: function() {
    var event = new BaseMonitor.ViewEvent(this.userId, this.userType, this.getMediaId(this.media));
    event.hasViewed = true;
    this.updateUserState(event);
  },

  startMonitoring: function() {
    this.renderer = this.getRenderer();

    if(!this.renderer) return;

    this.renderer.emitter.on('presented', this.onPresented.bind(this));
    this.renderer.emitter.on('show', this.onShow.bind(this));
    this.renderer.emitter.on('hide', this.onHide.bind(this));
  },

  stopMonitoring: function() {
    this.renderer = this.getRenderer();

    if(!this.renderer) return;

    this.renderer.emitter.off('presented', this.onPresented);
    this.renderer.emitter.off('show', this.onShow);
    this.renderer.emitter.off('hide', this.onHide);
  }
});

export default StaticMediaSessionMonitor;
